<div class="c-field-value -money" [ngClass]="customClass">
  <ng-container [ngSwitch]="true">
    <ng-container *ngSwitchCase="+data === 0">
      <span class="c-field-value__text -gray" [class.-white]="customClass === '-dark'"> {{ data }}% </span>
    </ng-container>
    <ng-container *ngSwitchCase="+data < 0">
      <span class="c-field-value__text -red"> ({{ transformPositive(data) | number : '.1-2' }}%) </span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <span class="c-field-value__text -green"> {{ data | number : '.1-2' }}% </span>
    </ng-container>
  </ng-container>
</div>
